import InlineScript from '@/lib/cookieconsent/InlineScript';

const BodyScripts = () => {
  const inProduction = process.env.NODE_ENV === 'production';

  return (
    <>
      {inProduction && <Matomo />}
    </>
  );
};

const Matomo = () => {
  return (
    <InlineScript service="matomo">
      {`
        var _paq = window._paq = window._paq || [];
        _paq.push(['setDocumentTitle', document.domain + "/" + document.title]);
        _paq.push(['enableCrossDomainLinking']);
        _paq.push(['setDoNotTrack', true]);
        _paq.push(['disableCookies']);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u="//piwik.webagentur-helm.de/";
          _paq.push(["setTrackerUrl", u+"matomo.php"]);
          _paq.push(["setSiteId", "24"]);

          // Also send all of the tracking data to this other Matomo server
          var secondaryTrackerUrl = '//matomo.diakonie-hamburg.de/matomo.php';
          var secondaryWebsiteId = 18;
          _paq.push(['addTracker', secondaryTrackerUrl, secondaryWebsiteId]);

          var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0];
          g.type="text/javascript"; g.async=true; g.defer=true; g.src=u+"piwik.js"; s.parentNode.insertBefore(g,s);
        })();
      `}
    </InlineScript>
  );
};

export default BodyScripts;
